<template>
	<div 
        @click="$router.push(link)"
        class="bg-white border-2 border-white hover:border-[#302E81] transform hover:rotate-1 transition duration-200 cursor-pointer rounded-xl px-4 py-3 shadow-lg">
		<div class="w-full flex justify-start items-center gap-4">
            <div>
                <LucideIcon :name="icon" :size="32" :stroke-width="1.6" color="#302E81" class="hidden lg:block" />
                <LucideIcon :name="icon" :size="24" :stroke-width="1.6" color="#302E81" class="lg:hidden"/>
            </div>
			<div class="">
				<p v-if="title" class="text-normal text-sm font-medium text-gray-800">{{title}}</p>
				<p v-if="subText" class="text-xs font-medium text-gray-800 line-clamp-2"> {{subText}}</p>
			</div>
		</div>
	</div>
</template>

<script>
import LucideIcon from "@/components/LucideIcon.vue";

export default {
	name:"WhiteBox",
	components:{
        LucideIcon
	},
	props:{
		title:{
			type:String
		},
		subText:{
			type:String
		},
        icon:{
			type:String
		},
        link:{
			type:String
		}
	},
	data(){
		return{

		}
	},
	mounted(){

	}

}
</script>

<style>

</style>